import { SVGProps } from 'react';

const FileKey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m16 10-4.5 4.5M15 11l1 1M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7zm-3 14a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default FileKey;
